/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 1.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { ReportGenerationBreachRequest } from '../models';
import { ReportGenerationBreachViewIEnumerableResponse } from '../models';
import { TABreachRequest } from '../models';
import { TABreachViewIEnumerableResponse } from '../models';
/**
 * BreachApi - axios parameter creator
 * @export
 */
export const BreachApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {TABreachRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BreachGetBreachesPost: async (body?: TABreachRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Breach/GetBreaches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportGenerationBreachRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BreachGetReportGenerationBreachesPost: async (body?: ReportGenerationBreachRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Breach/GetReportGenerationBreaches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BreachApi - functional programming interface
 * @export
 */
export const BreachApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {TABreachRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BreachGetBreachesPost(body?: TABreachRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TABreachViewIEnumerableResponse>> {
            const localVarAxiosArgs = await BreachApiAxiosParamCreator(configuration).apiV1BreachGetBreachesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {ReportGenerationBreachRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BreachGetReportGenerationBreachesPost(body?: ReportGenerationBreachRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportGenerationBreachViewIEnumerableResponse>> {
            const localVarAxiosArgs = await BreachApiAxiosParamCreator(configuration).apiV1BreachGetReportGenerationBreachesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BreachApi - factory interface
 * @export
 */
export const BreachApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {TABreachRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BreachGetBreachesPost(body?: TABreachRequest, options?: any): AxiosPromise<TABreachViewIEnumerableResponse> {
            return BreachApiFp(configuration).apiV1BreachGetBreachesPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportGenerationBreachRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BreachGetReportGenerationBreachesPost(body?: ReportGenerationBreachRequest, options?: any): AxiosPromise<ReportGenerationBreachViewIEnumerableResponse> {
            return BreachApiFp(configuration).apiV1BreachGetReportGenerationBreachesPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BreachApi - object-oriented interface
 * @export
 * @class BreachApi
 * @extends {BaseAPI}
 */
export class BreachApi extends BaseAPI {
    /**
     * 
     * @param {TABreachRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BreachApi
     */
    public apiV1BreachGetBreachesPost(body?: TABreachRequest, options?: any) {
        return BreachApiFp(this.configuration).apiV1BreachGetBreachesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {ReportGenerationBreachRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BreachApi
     */
    public apiV1BreachGetReportGenerationBreachesPost(body?: ReportGenerationBreachRequest, options?: any) {
        return BreachApiFp(this.configuration).apiV1BreachGetReportGenerationBreachesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
